import { GppGoodOutlined as GppGoodOutlinedIcon } from '@mui/icons-material';

const GppGoodOutlined = (): JSX.Element => <GppGoodOutlinedIcon fontSize="inherit" />;

export default GppGoodOutlined;
